
  import { defineComponent, reactive } from "vue"
  // import { EmitITFC } from "@/models/root"
  import "./scss/DropList.scss"

  export default defineComponent({
    name: "DropList",
    props: {
      list: Array,
    },
    emits: ["setItem"],
    setup(_: any, { emit }: any) {
      const isOpen = reactive({ value: false, activeElement: null })

      const setOpen = () => (isOpen.value = !isOpen.value)
      const setItem = (item: any) => {
        isOpen.activeElement = item.key
        emit("setItem", item)
      }

      return { isOpen, setOpen, setItem }
    },
  })
